<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <CategoryTable />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import CategoryTable from "./components/CategoryTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    CategoryTable,
    // ProjectsTable,
  },
};
</script>
